import { init, track, identify, setUserId } from '@amplitude/analytics-browser';

export const initAmplitude = () => {
  init(process.env.REACT_APP_AMPLITUDE_API_KEY, {
    defaultTracking: {
      sessions: true,
      pageViews: true,
      formInteractions: false,
    },
    ingestionMetadata: {
      sourceName: 'quiz-web',
      sourceVersion: '1.0.0'
    },
    transport: 'beacon',
  });
};

export const trackEvent = (eventName, eventProperties = {}) => {
  track(eventName, eventProperties);
};

export const identifyUser = (user) => {
  const userIdentity = identify()
    .set('email', user.email)
    .set('name', user.name)
    .set('signup_date', new Date(user.createdAt).toISOString());

  identify(userIdentity);
  setUserId(user._id);
};
